import { useEffect } from "react";
import ProgressBar from "components/ProgressBar";
import LeftPanel from "panels/LeftPanel";
import TopPanel from "panels/TopPanel";
import DomEvents from "events/DomEvents";
import OrthobarWidth from "components/OrthobarWidth";
import CircularProgressWithBackdrop from "components/CircularProgressWithBackdrop";
import ToolbarTime from "components/ToolbarTime";

export default function Panels ()  {
    useEffect(() => {
        document.addEventListener("mousedown", DomEvents.onMouseDown, false);
        document.addEventListener("mousemove", DomEvents.onMouseMove, false);
        document.addEventListener("touchstart", DomEvents.onMouseClick, false);
        document.addEventListener("mouseup", DomEvents.onMouseUp, false);
        document.addEventListener("touchend", DomEvents.onMouseUp, false);
        document.addEventListener("click", DomEvents.onMouseClick, false);
        document.addEventListener("keydown", DomEvents.onKeyDown, false);
        return () => {
            document.removeEventListener("mousedown", DomEvents.onMouseDown, false);
            document.removeEventListener("mousemove", DomEvents.onMouseMove, false);
            document.removeEventListener("touchstart", DomEvents.onMouseClick, false);
            document.removeEventListener("mouseup", DomEvents.onMouseUp, false);
            document.removeEventListener("touchend", DomEvents.onMouseUp, false);
            document.removeEventListener("click", DomEvents.onMouseClick, false);
            document.removeEventListener("keydown", DomEvents.onKeyDown, false);
        }
    }, [])

    return (
        <div>
            <CircularProgressWithBackdrop />
            <ProgressBar />
            <TopPanel />
            <LeftPanel />
            <OrthobarWidth />
            <ToolbarTime />
        </div>
    );
}
